import script from "./TextContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextContent.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./TextContent.vue?vue&type=style&index=0&id=ae27ebde&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__